import { commonMessages } from 'utils/messages'
import { ITermsAndConditionsPayload } from './TermsAndConditions.interface'
import { CancelTokenSource } from 'axios'
import { onCreateEndpointsWithClientid } from 'utils/common'
import { ENDPOINTS } from 'const/endpoints'
import axios from 'services/axios'

export function updateTermsAndConditions(
	id: string | undefined,
	data: Partial<ITermsAndConditionsPayload>,
	source?: CancelTokenSource,
) {
	const promise = axios.patch<ITermsAndConditionsPayload>(
		ENDPOINTS.TERMS_AND_CONDITIONS + '/' + id,
		data,
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}
